(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
/* Vanilla JS auto slider (no jQuery). Re-inits inside Theme Editor too. */
(function() {
  function initSlider(scope) {
    (scope || document).querySelectorAll('.announcement-bar-slider').forEach(function(wrapper) {
      var track = wrapper.querySelector('.slider-track');
      if (!track) return;

      var slides = Array.from(track.children);
      var total = slides.length;
      if (total <= 1) return; // auto even with 2; change to <=2 if you want min 3

      var index = 0;
      var intervalId = null;
      var delay = parseInt(wrapper.getAttribute('data-autoplay-ms') || '4000', 10);

      function go(i) {
        index = (i + total) % total;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
      }

      function start() {
        stop();
        intervalId = setInterval(function() { go(index + 1); }, delay);
        wrapper._auto = intervalId;
      }

      function stop() {
        if (wrapper._auto) clearInterval(wrapper._auto);
        if (intervalId) clearInterval(intervalId);
        wrapper._auto = null;
      }

      // Store cleanup so Theme Editor unload works
      wrapper._cleanup = stop;

      // Kickoff
      start();

      // Pause on hover (optional; remove if not needed)
      wrapper.addEventListener('mouseenter', stop);
      wrapper.addEventListener('mouseleave', start);
    });
  }

  document.addEventListener('DOMContentLoaded', function() { initSlider(document); });

  // Re-init when section is loaded/changed in Theme Editor
  document.addEventListener('shopify:section:load', function(e) { initSlider(e.target); });
  document.addEventListener('shopify:section:select', function(e) { initSlider(e.target); });
  document.addEventListener('shopify:section:unload', function(e) {
    var el = e.target.querySelector('.announcement-bar-slider');
    if (el && el._cleanup) el._cleanup();
  });

  // Close button (kept from original)
  document.addEventListener('click', function(e) {
    if (e.target.closest('.btn-close')) {
      var parent = e.target.closest('.parent-close');
      if (parent) parent.style.display = 'none';
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
